import { MenuOutlined } from '@ant-design/icons';
import { Button, Dropdown, type MenuProps } from 'antd';

import { RefundWindow } from '@app/components/Chat/components';
import { PaidModal } from '@app/components/Modals/PaidModal';

import { useLeadCardMenuActions } from './hooks/useLeadCardMenuActions';

export const UserActionsMenu = () => {
  const {
    actionBranchId,
    client,
    goToEdit,
    goToHistory,
    handleTopClientBalance,
    hasUserRightToEdit,
    hasUserRightToNavigateToLead,
    hasUserRightToReturnMoney,
    hasUserRightToTopClientBalance,
    isClientActionAvailable,
    isPaidModalLoading,
    isPaidModalOpen,
    isRefundWindowOpen,
    isUserDetailsLoading,
    openBalanceModal,
    openLeadCardPage,
    openRefundWindow,
    refetchLeadHistory,
    setIsPaidModalOpen,
    setIsRefundWindowOpen,
    sidebarInfo,
    updateClientAfterRefund,
  } = useLeadCardMenuActions();

  const items: MenuProps['items'] = [
    ...(hasUserRightToEdit
      ? [
          {
            key: 'edit',
            label: 'Редактировать',
            disabled: !isClientActionAvailable,
            onClick: goToEdit,
          },
        ]
      : []),
    {
      key: 'visit-history',
      label: 'История визитов',
      disabled: !isClientActionAvailable,
      onClick: goToHistory,
    },
    ...(hasUserRightToTopClientBalance
      ? [
          {
            key: 'top-up-balance',
            label: 'Пополнить баланс',
            disabled: !isClientActionAvailable,
            onClick: openBalanceModal,
          },
        ]
      : []),
    ...(hasUserRightToReturnMoney
      ? [
          {
            key: 'refund-from-balance',
            label: 'Возврат с баланса',
            disabled: !isClientActionAvailable,
            onClick: openRefundWindow,
          },
        ]
      : []),
    ...(hasUserRightToNavigateToLead
      ? [
          {
            key: 'go-to-lead',
            label: 'Перейти к лиду',
            onClick: openLeadCardPage,
          },
        ]
      : []),
  ];

  return (
    <>
      <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
        <Button
          className="UserActionsMenu__trigger"
          type="text"
          size="small"
          icon={<MenuOutlined />}
          aria-label="Меню"
        />
      </Dropdown>

      {hasUserRightToTopClientBalance && (
        <PaidModal
          isPaidModalOpen={isPaidModalOpen}
          setIsPaidModalOpen={setIsPaidModalOpen}
          handleTopClientBalance={handleTopClientBalance}
          IsPaidModalLoading={isPaidModalLoading}
          branchId={actionBranchId}
        />
      )}

      {hasUserRightToReturnMoney && (
        <RefundWindow
          client={client}
          sidebarInfo={sidebarInfo}
          isClientForViewLoading={isUserDetailsLoading}
          isRefundWindow={isRefundWindowOpen}
          setIsRefundWindow={setIsRefundWindowOpen}
          setClientInfo={updateClientAfterRefund}
          refetchHistory={refetchLeadHistory}
        />
      )}
    </>
  );
};
